import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './RefundPage.css';

const RefundPage = () => {
  const handleEnrollClick = () => {
    window.location.href = '/#home';
  };

  useEffect(() => {
    // Fix all anchor links on the page
    const fixAnchorLinks = () => {
      const anchors = document.querySelectorAll('a[href^="#"]');
      
      anchors.forEach(anchor => {
        anchor.addEventListener('click', (e) => {
          e.preventDefault();
          const hash = anchor.getAttribute('href');
          window.location.href = '/' + hash;
        });
      });
    };

    setTimeout(fixAnchorLinks, 100);
    
    const observer = new MutationObserver(fixAnchorLinks);
    observer.observe(document.body, { childList: true, subtree: true });
    
    return () => observer.disconnect();
  }, []);

  return (
    <div className="refund-page">
      <Header onEnrollClick={handleEnrollClick} />
      
      <main className="refund-main">
        <div className="refund-container" style={{marginTop : '50PX'}}>
          {/* Header */}
          <header className="refund-header">
            <h1>Refund Policy</h1>
            <div className="meta-info">
              <p><strong>Effective Date:</strong> {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
              <p><strong>Last Updated:</strong> {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
            </div>
          </header>

          {/* Important Notice */}
          <div className="important-notice">
            <div className="notice-icon">⚠️</div>
            <div className="notice-content">
              <h3>Important Notice</h3>
              <p>
                <strong>No refunds will be issued once payment is completed.</strong> By making payment for the DYLORA 1+1 Internship Program, you acknowledge and agree to this no-refund policy.
              </p>
            </div>
          </div>

          {/* Content */}
          <div className="refund-content">
            
            <section className="refund-section">
              <h2>1. No Refund Policy</h2>
              <p>
                DYLORA maintains a strict <strong>NO REFUND POLICY</strong> for all payments made towards the 1+1 Internship Program. Once payment is successfully processed, no refunds will be issued under any circumstances.
              </p>
              
              <div className="no-refund-box">
                <h3>Payment Confirmation Means Acceptance</h3>
                <p>
                  Your payment serves as confirmation that you have:
                </p>
                <ul>
                  <li>Read and understood all program details</li>
                  <li>Agreed to the program terms and conditions</li>
                  <li>Committed to participating in the complete 2-month program</li>
                  <li>Accepted this no-refund policy</li>
                </ul>
              </div>
            </section>

            <section className="refund-section">
              <h2>2. Program Access & Benefits</h2>
              <p>
                Upon successful payment, you immediately gain access to:
              </p>
              
              <div className="benefits-grid">
                <div className="benefit-item">
                  <div className="benefit-icon">🎯</div>
                  <h3>Program Enrollment</h3>
                  <p>Confirmed seat in the internship program batch</p>
                </div>
                
                <div className="benefit-item">
                  <div className="benefit-icon">📚</div>
                  <h3>Learning Materials</h3>
                  <p>Access to all training resources and study materials</p>
                </div>
                
                <div className="benefit-item">
                  <div className="benefit-icon">👨‍🏫</div>
                  <h3>Mentor Access</h3>
                  <p>Direct access to industry mentors and trainers</p>
                </div>
                
                <div className="benefit-item">
                  <div className="benefit-icon">📋</div>
                  <h3>Program Resources</h3>
                  <p>All program resources allocated to your account</p>
                </div>
              </div>
            </section>

            <section className="refund-section">
              <h2>3. Non-Refundable Circumstances</h2>
              <p>
                Refunds will NOT be issued in the following situations:
              </p>
              
              <div className="circumstances-table">
                <div className="table-header">
                  <div className="col-circumstance">Circumstance</div>
                  <div className="col-explanation">Explanation</div>
                </div>
                
                <div className="table-row">
                  <div className="col-circumstance">Change of Mind</div>
                  <div className="col-explanation">If you change your mind after payment</div>
                </div>
                
                <div className="table-row">
                  <div className="col-circumstance">Non-Participation</div>
                  <div className="col-explanation">If you choose not to attend sessions</div>
                </div>
                
                <div className="table-row">
                  <div className="col-circumstance">Schedule Conflicts</div>
                  <div className="col-explanation">Personal schedule conflicts or time constraints</div>
                </div>
                
                <div className="table-row">
                  <div className="col-circumstance">Technical Issues</div>
                  <div className="col-explanation">Personal internet or device issues</div>
                </div>
                
                <div className="table-row">
                  <div className="col-circumstance">Performance Issues</div>
                  <div className="col-explanation">Inability to complete assignments or projects</div>
                </div>
                
                <div className="table-row">
                  <div className="col-circumstance">Certificate Non-Issuance</div>
                  <div className="col-explanation">If certificates are not earned due to non-completion</div>
                </div>
              </div>
            </section>

            <section className="refund-section">
              <h2>4. Payment Confirmation</h2>
              
              <div className="confirmation-steps">
                <div className="step">
                  <div className="step-number">1</div>
                  <div className="step-content">
                    <h3>Payment Processing</h3>
                    <p>Payment is processed immediately upon submission</p>
                  </div>
                </div>
                
                <div className="step">
                  <div className="step-number">2</div>
                  <div className="step-content">
                    <h3>Confirmation Email</h3>
                    <p>You receive payment confirmation email within 24 hours</p>
                  </div>
                </div>
                
                <div className="step">
                  <div className="step-number">3</div>
                  <div className="step-content">
                    <h3>Program Access</h3>
                    <p>Program access details sent via email and WhatsApp</p>
                  </div>
                </div>
                
                <div className="step">
                  <div className="step-number">4</div>
                  <div className="step-content">
                    <h3>Binding Agreement</h3>
                    <p>Payment confirmation serves as binding agreement to terms</p>
                  </div>
                </div>
              </div>
            </section>

            <section className="refund-section">
              <h2>5. Program Transfer Policy</h2>
              <p>
                While refunds are not permitted, we may consider the following <strong>on a case-by-case basis only</strong>:
              </p>
              
              <div className="transfer-options">
                <div className="option-item">
                  <div className="option-badge">Case-by-Case</div>
                  <h3>Batch Transfer</h3>
                  <p>Transfer to next available batch may be considered in exceptional circumstances</p>
                </div>
                
                <div className="option-item">
                  <div className="option-badge">Rare Consideration</div>
                  <h3>Course Credit</h3>
                  <p>Credit towards future programs may be considered in medical emergencies</p>
                </div>
              </div>
              
              <div className="disclaimer">
                <p>
                  <strong>Important:</strong> Transfers or credits are NOT guaranteed and are evaluated on individual merit. There is no obligation to provide any alternative arrangements.
                </p>
              </div>
            </section>

            <section className="refund-section">
              <h2>6. Payment Methods</h2>
              <p>
                All payments are processed through secure channels. Accepted payment methods include:
              </p>
              
              <div className="payment-methods">
                <div className="method">UPI Payments</div>
                <div className="method">Bank Transfer</div>
                <div className="method">Online Payment Gateways</div>
                <div className="method">Other methods as specified</div>
              </div>
              
              <p className="note">
                <strong>Note:</strong> Payment instructions are provided exclusively through our official WhatsApp group after registration. Never make payments through unofficial channels.
              </p>
            </section>

            <section className="refund-section">
              <h2>7. Cancellation by DYLORA</h2>
              <p>
                In the extremely rare event that DYLORA needs to cancel a program batch:
              </p>
              
              <div className="cancellation-policy">
                <div className="policy-item">
                  <div className="policy-icon">✅</div>
                  <div className="policy-content">
                    <h3>Full Refund or Transfer</h3>
                    <p>You will receive a full refund OR option to transfer to next batch</p>
                  </div>
                </div>
                
                <div className="policy-item">
                  <div className="policy-icon">✅</div>
                  <div className="policy-content">
                    <h3>Timely Notification</h3>
                    <p>Notification will be provided at least 7 days in advance</p>
                  </div>
                </div>
                
                <div className="policy-item">
                  <div className="policy-icon">✅</div>
                  <div className="policy-content">
                    <h3>Refund Processing</h3>
                    <p>Refunds processed within 14 business days if applicable</p>
                  </div>
                </div>
              </div>
            </section>

            <section className="refund-section">
              <h2>8. Your Responsibility</h2>
              <p>
                Before making payment, you are responsible for:
              </p>
              
              <div className="responsibility-list">
                <div className="responsibility-item">
                  <div className="check-icon">✓</div>
                  <span>Reading all program details carefully</span>
                </div>
                
                <div className="responsibility-item">
                  <div className="check-icon">✓</div>
                  <span>Understanding the time commitment required</span>
                </div>
                
                <div className="responsibility-item">
                  <div className="check-icon">✓</div>
                  <span>Checking technical requirements for online sessions</span>
                </div>
                
                <div className="responsibility-item">
                  <div className="check-icon">✓</div>
                  <span>Reviewing schedule and ensuring availability</span>
                </div>
                
                <div className="responsibility-item">
                  <div className="check-icon">✓</div>
                  <span>Reading and understanding this refund policy</span>
                </div>
              </div>
            </section>

            <section className="refund-section">
              <h2>9. Contact for Clarifications</h2>
              
              <div className="contact-clarification">
                <p>
                  If you have any questions or need clarification about this refund policy <strong>BEFORE making payment</strong>, please contact us:
                </p>
                
                <div className="contact-details">
                  <div className="contact-item">
                    <strong>Email:</strong> contact@dylora.in
                  </div>
                  
                  <div className="contact-item">
                    <strong>WhatsApp:</strong> +91 70212 88082
                  </div>
                  
                  <div className="contact-item">
                    <strong>Clarification:</strong> Please clarify all doubts BEFORE payment
                  </div>
                </div>
                
                <div className="final-note">
                  <p>
                    <strong>Final Note:</strong> Once payment is made, it is considered final and non-refundable. We encourage you to ask all questions and seek clarifications before proceeding with payment.
                  </p>
                </div>
              </div>
            </section>

            <section className="refund-section acknowledgement">
              <h2>Acknowledgement & Acceptance</h2>
              <p>
                By proceeding with payment for the DYLORA 1+1 Internship Program, you acknowledge that:
              </p>
              
              <div className="acknowledgement-list">
                <div className="ack-item">
                  <div className="ack-icon">✅</div>
                  <div className="ack-content">
                    You have read and understood this Refund Policy in its entirety
                  </div>
                </div>
                
                <div className="ack-item">
                  <div className="ack-icon">✅</div>
                  <div className="ack-content">
                    You agree to the no-refund terms stated herein
                  </div>
                </div>
                
                <div className="ack-item">
                  <div className="ack-icon">✅</div>
                  <div className="ack-content">
                    You understand that payment is final and non-refundable
                  </div>
                </div>
                
                <div className="ack-item">
                  <div className="ack-icon">✅</div>
                  <div className="ack-content">
                    You accept full responsibility for your payment decision
                  </div>
                </div>
              </div>
              
              <div className="signature">
                <p><strong>The DYLORA Team</strong></p>
                <p>DYLORA Internship Program</p>
              </div>
            </section>

          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default RefundPage;